import { Navigate, useLocation } from 'react-router-dom';
import { useAppSelector } from '@shared/store/hooks';
import type { RootState } from '@shared/store';

interface RequireAuthProps {
  children: JSX.Element;
}

export function RequireAuth({ children }: RequireAuthProps) {
  const location = useLocation();
  const isAuthenticated = useAppSelector((state: RootState) => state.exchange.isAuthenticated);

  if (!isAuthenticated) {
    return <Navigate to="/auth/login" replace state={{ from: location.pathname }} />;
  }

  return children;
}
